import React, { Component } from 'react'
import TopNav from '../../components/topnav/topnav';
import Footer from '../../components/footer/footer';
import Banner from '../../components/privacypolicy/banner'
import { Layout, Typography, Icon } from 'antd';
import { Helmet } from "react-helmet";
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getPP } from '../../../../core/actions/ppcontents';
const { Title } = Typography;
const { Content } = Layout;
class Privacy extends Component {
  constructor(props) {
    super(props)
    this.state = {
      content: ''
    }
  }

  componentWillMount() {
    window.scrollTo({ top: 0 });
  }

  componentDidMount() {
    window.fbq('track', 'ViewContent');
    this.props.getPP()
  }

  componentWillReceiveProps(nextProps) {
    let { ppContent } = nextProps
    if (ppContent.content.length > 0) {
      this.setState({
        content: ppContent.content
      })
    }
  }

  render() {
    const { content } = this.state
    return (
      <div>
        <Helmet>
          <title>Privacy policy</title>
        </Helmet>
        {
          content.length ?
            <div className="privacy-page">
              <TopNav history={this.props.history} />
              <Banner />
              <Content >
                <div className="main">
                  <section className="privacy-holder" dangerouslySetInnerHTML={{ __html: content }}>
                  </section>
                </div>
              </Content>
              <Footer />
            </div>
            :
            <div className="x-loader">
              <Icon type="loading" style={{ fontSize: 60 }} spin />
            </div>
        }
      </div>
    )
  }
}


const mapStateToProps = (state) => ({
  ppContent: state.ppContents.ppContent
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getPP
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Privacy)
